import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import type { NurseResponse } from "@/types/nurse-type";
import {
  createNurseCacheScopeKeys,
  replaceNurseSequenceForCache,
  type RosterCreateNurseRow,
} from "../utils/rosterCreateNurseReorderUtils";

export function useRosterCreateNurseSequenceCache(groupId?: string | null) {
  const queryClient = useQueryClient();

  const patchCaches = useCallback(
    (nextRows: readonly RosterCreateNurseRow[]) => {
      createNurseCacheScopeKeys(groupId).forEach((queryKey) => {
        queryClient.setQueriesData<NurseResponse[] | undefined>(
          { queryKey },
          (previous) => replaceNurseSequenceForCache(previous, nextRows)
        );
      });
    },
    [groupId, queryClient]
  );

  const invalidateSequenceCaches = useCallback(async () => {
    await Promise.all(
      createNurseCacheScopeKeys(groupId).map((queryKey) =>
        queryClient.invalidateQueries({ queryKey })
      )
    );
  }, [groupId, queryClient]);

  return {
    invalidateSequenceCaches,
    patchCaches,
  };
}
